
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn
      flat fab slot="activator" style="margin-top:-20px"
      class="indigo accent-1" light small mt-4 absolute middle right
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new unit</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout mx-3 my-3 column>
            <v-flex xs6 offset-xs0>
              <v-layout row>
                <v-flex xs6>
                  <v-text-field  v-if="showDialog" autofocus v-model="newUnit.name"
                    name="unitName" label="Unit Name"
                    :rules="[rules.required, rules.min]"/>
                </v-flex>
              </v-layout>
              <provenance-and-note v-bind:record="newUnit"/>
 
              <v-layout row>
                <v-flex xs12>
                  <div class="error" v-html="error"></div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn dark class="indigo darken-1" :loading="loading" @click="createUnit">
                    <v-icon left>save_alt</v-icon>Define New Unit
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>
import Panel from "@/components/Panel";
import UnitService from "@/services/UnitService";

export default {
  components: { Panel },
  data () {
    return {
      newUnit: {
        name: "",
        provenance: "",
        note: ""
      },
      error: null,
      message: null,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Minimum of 8 characters is required."
      },
      loading: false,
      showDialog: false
    };
  },

  methods: {
    async createUnit () {
      console.log("IN createUnit");
      if (!this.$refs.form.validate()) return ;

      this.error = null ;
      try {
        this.loading = true ;
        const response = await UnitService.create(this.newUnit);
        console.log("createUnit response: " + response);
        this.showDialog = false ;
        this.$renderToastInParent(this, "Unit " + this.newUnit.name + " successfully created") ;
      }
      catch (err) {
        console.log("catch err:" + err);
        this.error = err.response.data.error ;
      }
      finally {
        this.loading = false ;
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UnitCreate.vue